import { IS_ORDER } from '../../action-types/ui/isOrder';

export const isOrder = flag => ({
  type: IS_ORDER,
  flag,
});



// WEBPACK FOOTER //
// ./src/redux/actions/ui/isOrder.js